import { useSyncExternalStore } from 'react';

const subscribe = (onChange: () => void) => {
  window.addEventListener('storage', onChange);
  return () => window.removeEventListener('storage', onChange);
};

// eslint-disable-next-line no-restricted-globals -- legacy: View As keys stay on the device until the server holds View As (backend ask)
const getSnapshot = () => localStorage.getItem('isViewing') === 'true';

const getServerSnapshot = () => false;

export const useIsViewing = () => useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
